import { render, staticRenderFns } from "./ModalDocumentTemplate.vue?vue&type=template&id=70e892c2&scoped=true"
import script from "./ModalDocumentTemplate.vue?vue&type=script&lang=js"
export * from "./ModalDocumentTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e892c2",
  null
  
)

export default component.exports